import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import BlockModal from '../../../../../components/BlockModal/BlockModal';

import EditIcon from '@material-ui/icons/Edit';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import {
  getString,
  stripInvalidCharacters,
} from '../../../../../helpers/stringHelpers.js';
import constants from '../../../../../constants.js';

const stringsComponent = 'contactDetails';

const WAIT_INTERVAL = 250;

class ContactDetailsDialog extends React.Component {
  constructor(props) {
    super(props);

    const { initialDialogData } = props;

    this.state = {
      dialogData: initialDialogData,
      mobilePhoneError: false,
      mobilePhoneNameError: false,
      preferredPhoneError: false,
      preferredPhoneNameError: false,
      emailError: false,
      error: false,
      dirty: false,
      blockModalOpen: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBlockModalCancel = this.handleBlockModalCancel.bind(this);
    this.handleBlockModalConfirm = this.handleBlockModalConfirm.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    this.timer = null;
  }

  handleChange(event) {
    clearTimeout(this.timer);
    const target = event.target.name;
    const value = event.target.value;

    const newDialogData = { ...this.state.dialogData };
    newDialogData[target] = value;

    this.setState({
      dialogData: newDialogData,
    });

    // We set an error, so the button is disabled until validation is run
    this.setState({ error: true });
    this.timer = setTimeout(this.validate, WAIT_INTERVAL);
  }

  handleCancel() {
    const { handleCancel } = this.props;
    const { dirty } = this.state;

    if (dirty) {
      this.setState({
        blockModalOpen: true,
      });
    } else {
      handleCancel();
    }
  }

  handleBlockModalCancel() {
    this.setState({
      blockModalOpen: false,
    });
  }

  handleBlockModalConfirm() {
    const { handleCancel } = this.props;

    this.setState({ blockModalOpen: false });
    handleCancel();
  }

  validate() {
    const phoneReg = constants.PHONE_REGEX;
    const emailReg = constants.EMAIL_REGEX;
    const nameReg = new RegExp(`.{${constants.NAME_MIN_LENGTH},}`);

    const { dialogData } = this.state;
    const { initialDialogData } = this.props;

    this.setState(
      {
        mobilePhoneError:
          ((dialogData.mobilePhoneName || initialDialogData.mobilePhoneName) &&
            !dialogData.mobilePhone) ||
          (!phoneReg.test(dialogData.mobilePhone) &&
            (initialDialogData.mobilePhone != dialogData.mobilePhone ||
              initialDialogData.mobilePhoneName != dialogData.mobilePhoneName))
            ? true
            : false,
        mobilePhoneNameError:
          (dialogData.mobilePhone ||
            initialDialogData.mobilePhone ||
            dialogData.mobilePhoneName) &&
          (dialogData.mobilePhoneName ||
            initialDialogData.mobilePhoneName ||
            initialDialogData.mobilePhone != dialogData.mobilePhone) &&
          (!nameReg.test(dialogData.mobilePhoneName.trim()) ||
            stripInvalidCharacters(dialogData.mobilePhoneName).length <
              constants.NAME_MIN_LENGTH)
            ? true
            : false,
        preferredPhoneError:
          ((dialogData.preferredPhoneName ||
            initialDialogData.preferredPhoneName) &&
            !dialogData.preferredPhone) ||
          (!phoneReg.test(dialogData.preferredPhone) &&
            (initialDialogData.preferredPhone != dialogData.preferredPhone ||
              initialDialogData.preferredPhoneName !=
                dialogData.preferredPhoneName))
            ? true
            : false,
        preferredPhoneNameError:
          (dialogData.preferredPhone ||
            initialDialogData.preferredPhone ||
            dialogData.preferredPhoneName) &&
          (dialogData.preferredPhoneName ||
            initialDialogData.preferredPhoneName ||
            initialDialogData.preferredPhone != dialogData.preferredPhone) &&
          (!nameReg.test(dialogData.preferredPhoneName.trim()) ||
            stripInvalidCharacters(dialogData.preferredPhoneName).length <
              constants.NAME_MIN_LENGTH)
            ? true
            : false,
        emailError:
          (initialDialogData.email || dialogData.email) &&
          !emailReg.test(dialogData.email) &&
          initialDialogData.email != dialogData.email
            ? true
            : false,
      },
      () => {
        this.setState({
          error:
            this.state.mobilePhoneError ||
            this.state.mobilePhoneNameError ||
            this.state.preferredPhoneError ||
            this.state.preferredPhoneNameError ||
            this.state.emailError,
          dirty:
            initialDialogData.mobilePhone != dialogData.mobilePhone ||
            initialDialogData.mobilePhoneName != dialogData.mobilePhoneName ||
            initialDialogData.preferredPhone != dialogData.preferredPhone ||
            initialDialogData.preferredPhoneName !=
              dialogData.preferredPhoneName ||
            initialDialogData.email != dialogData.email,
        });
      }
    );
  }

  render() {
    const { open, handleSubmit, handleCancel, classes } = this.props;

    const {
      dialogData,
      mobilePhoneError,
      mobilePhoneNameError,
      preferredPhoneError,
      preferredPhoneNameError,
      emailError,
      error,
      dirty,
      blockModalOpen,
    } = this.state;

    return (
      <div>
        <Dialog open={open}>
          <DialogTitle className={classes.title}>
            <div className={classes.heading}>
              <EditIcon className={classes.avatar} />
              <Typography variant='h3'>
                {getString(stringsComponent, 'DIALOG_TITLE')}
              </Typography>
            </div>
          </DialogTitle>
          <Divider />
          <br />
          <DialogContent>
            <Typography className={classes.formField}>
              {getString('app', 'ENGLISH_ONLY_TEXT')}
            </Typography>
            <br />
            <div className={classes.formField}>
              <Typography className={classes.label}>
                {getString(stringsComponent, 'MOBILE_LABEL')}
              </Typography>
              <TextField
                variant='outlined'
                className={classes.textFieldContainer}
                placeholder={getString(stringsComponent, 'MOBILE_EXAMPLE')}
                inputProps={{
                  className: classes.textInput,
                }}
                name='mobilePhone'
                value={dialogData.mobilePhone}
                onChange={this.handleChange}
              />
            </div>
            <Typography component='div' className={classes.validation}>
              {mobilePhoneError
                ? getString(stringsComponent, 'PHONE_HELP_TEXT')
                : ''}
            </Typography>
            <br />
            <div className={classes.formField}>
              <Typography className={classes.label}>
                {getString(stringsComponent, 'MOBILE_NAME_LABEL')}
              </Typography>
              <TextField
                variant='outlined'
                className={classes.textFieldContainer}
                placeholder={getString(stringsComponent, 'MOBILE_NAME_EXAMPLE')}
                inputProps={{
                  className: classes.textInput,
                }}
                name='mobilePhoneName'
                value={dialogData.mobilePhoneName}
                onChange={this.handleChange}
              />
            </div>
            <Typography component='div' className={classes.validation}>
              {mobilePhoneNameError
                ? getString(stringsComponent, 'REQUIRED_HELP_TEXT')
                : ''}
            </Typography>
            <br />
            <div className={classes.formField}>
              <Typography className={classes.label}>
                {getString(stringsComponent, 'PHONE_LABEL')}
              </Typography>
              <TextField
                variant='outlined'
                className={classes.textFieldContainer}
                placeholder={getString(stringsComponent, 'PHONE_EXAMPLE')}
                inputProps={{
                  className: classes.textInput,
                }}
                name='preferredPhone'
                value={dialogData.preferredPhone}
                onChange={this.handleChange}
              />
            </div>
            <Typography component='div' className={classes.validation}>
              {preferredPhoneError
                ? getString(stringsComponent, 'PHONE_HELP_TEXT')
                : ''}
            </Typography>
            <br />
            <div className={classes.formField}>
              <Typography className={classes.label}>
                {getString(stringsComponent, 'PHONE_NAME_LABEL')}
              </Typography>
              <TextField
                variant='outlined'
                className={classes.textFieldContainer}
                inputProps={{
                  className: classes.textInput,
                }}
                name='preferredPhoneName'
                value={dialogData.preferredPhoneName}
                onChange={this.handleChange}
                placeholder={getString(stringsComponent, 'PHONE_NAME_EXAMPLE')}
              />
            </div>
            <Typography component='div' className={classes.validation}>
              {preferredPhoneNameError
                ? getString(stringsComponent, 'REQUIRED_HELP_TEXT')
                : ''}
            </Typography>
            <br />
            <div className={classes.formField}>
              <Typography className={classes.label}>
                {getString(stringsComponent, 'EMAIL_LABEL')}
              </Typography>
              <TextField
                variant='outlined'
                className={classes.textFieldContainer}
                inputProps={{
                  className: classes.textInput,
                }}
                name='email'
                value={dialogData.email}
                onChange={this.handleChange}
                placeholder={getString(stringsComponent, 'EMAIL_EXAMPLE')}
              />
            </div>
            <Typography component='div' className={classes.validation}>
              {emailError ? getString(stringsComponent, 'EMAIL_HELP_TEXT') : ''}
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button variant='outlined' onClick={this.handleCancel}>
              {getString(stringsComponent, 'CANCEL_LABEL')}
            </Button>
            <Button
              variant='outlined'
              color='primary'
              onClick={() => handleSubmit(this.state.dialogData)}
              disabled={error || !dirty}
            >
              {getString(stringsComponent, 'SAVE_LABEL')}
            </Button>
          </DialogActions>
        </Dialog>
        <BlockModal
          show={blockModalOpen}
          message={getString('blockModal', 'MESSAGE')}
          cancel={this.handleBlockModalCancel}
          ok={this.handleBlockModalConfirm}
          secondaryButtonLabel={getString('blockModal', 'BUTTON_LABEL_CANCEL')}
        />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ContactDetailsDialog);
